/** `app_open`: one per device per IST day (D-45), with the arrival source (BR-21). */
import { safeStorage } from '@/lib/storage'
import { istDay } from '@/lib/time'

import { refSource } from './source'
import { track } from './tracker'

const KEY = 'angadi.app_open_day'

export function logAppOpen(search: string = window.location.search, now = Date.now()): boolean {
  const day = istDay(now)
  if (safeStorage.get(KEY) === day) return false
  safeStorage.set(KEY, day)
  track('app_open', { source: refSource(search) ?? 'direct' })
  return true
}
